export const useWebsocketStore = defineStore('websocket', {
  state: () => ({
    socketId: '' as string
  }),
  actions: {
    setSocketId(id: string) {
      this.socketId = id
    }
  },
  getters: {
    getSocketId(): string {
      return this.socketId
    }
  }
})
